export default __webpack_public_path__ + "static/media/7.942fa1d7.png";